import Swiper from 'swiper'
import { Navigation, Thumbs } from 'swiper/modules'
import ThreeSixty from '@mladenilic/threesixty.js'

class Product {
    static productImages = document.querySelector('[data-module="product-images"]')
    static productThumbs = document.querySelector('[data-module="product-thumbs"]')
    static product360 = document.querySelector('[data-module="product-360"]')
    static productStickyCart = document.querySelector('[data-module="product-sticky-cart"]')
    static open360 = document.querySelector('#open-product-360')
    static close360 = document.querySelector('#close-product-360')
    static thumbsSwiper = null
    static thumbsNavPrev = this.productThumbs ? this.productThumbs.querySelector('.thumbs-button-prev') : null
    static thumbsNavNext = this.productThumbs ? this.productThumbs.querySelector('.thumbs-button-next') : null

    static init() {
        this.imagesSlider()
        this.image360()
        this.toggle360()
        this.stickyCart()
    }

    static imagesSlider() {
        if (!this.productImages) return

        if (this.productThumbs) {
            this.thumbsSwiper = new Swiper(this.productThumbs, {
                spaceBetween: 10,
                slidesPerView: 5,
                watchSlidesProgress: true,
            })

            this.thumbsNavigation(this.thumbsSwiper)
            this.handleThumbClick(this.thumbsSwiper)
        }

        // eslint-disable-next-line no-new
        new Swiper(this.productImages, {
            modules: [Navigation, Thumbs],
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 1,
            keyboard: true,
            navigation: {
                enabled: true,
                nextEl: '.gallery-button-next',
                prevEl: '.gallery-button-prev',
            },
            thumbs: {
                swiper: this.thumbsSwiper,
            },
        })
    }

    static thumbsNavigation(swiper) {
        if (!this.thumbsNavPrev || !this.thumbsNavNext) return

        this.thumbsNavPrev.addEventListener('click', () => {
            swiper.slidePrev()
        })

        this.thumbsNavNext.addEventListener('click', () => {
            swiper.slideNext()
        })
    }

    static handleThumbClick(swiper) {
        const thumbs = swiper.slides

        thumbs.forEach((thumb, index) => {
            thumb.addEventListener('click', () => {
                if (index === 0) {
                    swiper.slidePrev()
                } else if (index === thumbs.length - 1) {
                    swiper.slideNext()
                }
            })
        })
    }

    static image360() {
        if (!this.product360) return

        const updateDimensions = () => {
            const containerWidth = this.product360.clientWidth
            const containerHeight = this.product360.clientHeight
            const aspectRatio = parseInt(this.product360.dataset.width) / parseInt(this.product360.dataset.height)

            let width, height
            if (containerWidth / containerHeight > aspectRatio) {
                height = containerHeight
                width = height * aspectRatio
            } else {
                width = containerWidth
                height = width / aspectRatio
            }

            return { width, height }
        }

        const initialize360 = () => {
            const { width, height } = updateDimensions()

            if (this.image360Instance) {
                this.image360Instance.destroy()
            }

            this.image360Instance = new ThreeSixty(this.product360, {
                image: this.product360.dataset.image,
                count: parseInt(this.product360.dataset.count),
                width,
                height,
                perRow: 6,
                speed: 100,
                inverted: true,
            })
        }

        initialize360()

        window.addEventListener('resize', initialize360)
    }

    static toggle360() {
        if (!this.open360 || !this.close360) return

        this.open360.addEventListener('click', () => {
            this.product360.closest('.product-360-wrapper').setAttribute('active', '')
        })

        this.close360.addEventListener('click', () => {
            this.product360.closest('.product-360-wrapper').removeAttribute('active')
        })
    }

    static stickyCart() {
        if (!this.productStickyCart) return

        const cartElement = document.querySelector('.single-product .summary .cart')
        if (!cartElement) return

        this.checkCartPosition(cartElement)

        window.addEventListener('scroll', () => {
            this.checkCartPosition(cartElement)
        })
    }

    static checkCartPosition(element) {
        const cartOffsetTop = element.offsetTop
        if (window.scrollY > cartOffsetTop) {
            this.productStickyCart.setAttribute('active', '')
        } else {
            this.productStickyCart.removeAttribute('active')
        }
    }
}

export default (function () {
    Product.init()
})
